export const EXAMPLE_REACT_APP_BASE_URL = "https://example.icabbi.dev/api";

export function getReactAppBaseUrl() {
  return process.env.REACT_APP_BASE_URL ?? EXAMPLE_REACT_APP_BASE_URL;
}
